import { createReducer, on } from "@ngrx/store";

import { LoaderActions } from ".";

export interface LoaderState {
  loader: boolean;
}

export const initialState: LoaderState = {
  loader: false,
};

export const loaderReducer = createReducer(
  initialState,

  on(LoaderActions.startLoader, state => ({
    ...state,
    loader: true,
  })),

  on(LoaderActions.stopLoader, state => ({
    ...state,
    loader: false,
  }))
);
